import AuthFlowFrame from "../../components/AuthFlowFrame";
import { Content } from "@jobber/components/Content";
import { Text } from "@jobber/components/Text";
import { AuthFlowButton } from "../../types";
import syncCompleteImage from "assets/images/sync_complete.png";

function Step3() {
    const button: AuthFlowButton = {
        link: "https://secure.getjobber.com/home",
        text: "Go to Jobber",
        type: "primary",
        disabled: false,
        loading: false,
    }

    const secondaryButton: AuthFlowButton = {
        link: "https://go.xero.com",
        text: "Return to Xero",
        type: "secondary",
        disabled: false,
        loading: false,
    }

    return (
        <AuthFlowFrame
            pretitle={"You are all set"}
            title={"Xero Integration is ready to go!"}
            step={3}
            totalSteps={3}
            button={button}
            secondaryButton={secondaryButton}
        >
            <Content type={"div"} spacing={"largest"}>
                <Text size={"large"}>
                    Any new clients, invoices, or products and services on invoices in Jobber will now automatically
                    sync into your Xero account.
                </Text>
                <img src={syncCompleteImage} alt={"Sync complete"} style={{maxWidth: "100%"}}></img>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step3;
